import { otpActivationUrl, PRODUCTS, VDS_KEY } from "common/constants/apiUrls";
import { getData, patchData, postData } from "networkManager/NetworkManager";

const getProductList = async (params = {}) => {
  let url = `${VDS_KEY}/${PRODUCTS}?${Object.entries(params)
    .map(([key, val]) => `${key}=${val}`)
    .join("&")}`;
  return await getData(url);
};

const addNewProduct = async (payload) => {
  return await postData(PRODUCTS, payload);
};

const otpActivation = async (payload, productId) => {
  let url = otpActivationUrl(productId);
  return await patchData(url, payload);
};

export { getProductList, addNewProduct, otpActivation };
